var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"type":"primary","size":_vm.size,"disabled":_vm.disabled},on:{"click":_vm.onClick},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('IconLockOpen',{staticStyle:{"margin-right":"4px"},attrs:{"size":_vm.size}})]},proxy:true}])},[_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }